const choicesToLineItems = (choices: any[]) => choices.map((choice) => ({
  quantity: 1,
  unitPrice: choice.salePrice,
  SKU: choice.sku,
  productName: choice.name,
}));

export {
  // eslint-disable-next-line import/prefer-default-export
  choicesToLineItems,
};
